import { Fragment, h } from "preact";
import { AppPage } from '../../../_common/components/app-page'
import { useEffect, useState } from 'preact/hooks';
import { useSelector, useDispatch } from 'react-redux'
import { t } from '../../../_i18n'
import { Link, useLocation } from "react-router-dom";
import './dashboard-styles.scss'
import Card from '../../../_common/components/CardDashboard/Card'
import CardHelp from '../../../_common/components/CardDashboard/CardHelp'
import { isB2bUser, isItalianUser, isSpanishUser } from "../../../_common/utils/getLang";
import { C } from '../../../_common/layout'
import Comunicados from '../../../comunicados/comunicados'
import {STUDENT_IS_ON_SITE, STUDENT_NO_TITLE, STUDENT_NO_VALIDATED, STUDENT_VALIDATED} from '../../../app/getUserRol'
import Badge from '../../../_common/components/Badge'
import { fetchAcademicSection } from "../../../_rx/academic-sections/actions";
import crypto from 'crypto';
import {getHttp, isMobileAgent} from "../../../_common/common";
import {fetchPrestashopProducts} from "../../../_rx/prestashop-products/actions";
import CardSession from "../../../_common/components/CardDashboard/card-session";
import SalesBanner from '../../../sales-banner/sales-banner';
import Banner from "../../../_common/components/Banner";
import { convocationResignationsActiveProcess } from "../../../_rx/student/actions";
import TrialBanner from "../../../trial-banner/trial-banner";

export default function Dashboard() {
    const dispatch = useDispatch();
    const isMobile = isMobileAgent();
    const { user, comunicados_status, student_meta, student_access, lang, academicSection, prestashopProducts, convocationResignations} = useSelector(state => ({
        user: state.auth.loggedUser,
        comunicados_status: state.comunicados_status,
        student_meta: state.status.student_meta,
        student_access: state.student_access,
        lang: state.lang,
        academicSection: state.academicSection,
        prestashopProducts: state.prestashopProducts,
        convocationResignations: state.convocationResignations
    }));

    const availabeToFinishCAT2122 = student_meta.available_CAT2122.availableToFinish;
    const academicProgramNamesCAT2122 = student_meta.available_CAT2122.data.map(ciclo => ciclo.ciclo);

    const [colorClass, setColorClass] = useState('')
    const [backgroundClass, setBackgroundClass] = useState('')
    const [discountPercentage, setDiscountPercentage] = useState('')
    const [enrollPendingBlackFriday, setEnrollPendingBlackFriday] = useState(false)
    const [cartGeneratorUrl, setCartGeneratorUrl] = useState('')

    const currentSemesterId = 63;
    const desiredSemesterId = 73; // 2526 S1 semestre
    const desiredCursId = 66; // 2526 S0 periodo
    const location = useLocation();

    const saleBase = {
        modalTitle: t("Matricúlate para septiembre"),
        discountTitle: t("Matricúlate para septiembre"),
        discountSubtitle: t("Te hemos preparado la matrícula con una recomendación académica personalizada para el siguiente semestre."),
        buttonLabel: "¡Matricúlate ahora!",
        style: {
            backgroundColor: "black",
            buttonWidth: 300,
            textMaxWidth: 520,
        }
    }


    const studentType = student_meta.student_type;
    const studentSaleType = student_meta.formative_zone === 'MAD' ? 'annual' : 'semestral';
    const isTrial = studentType == 'trial';
    const isMixed = studentType == 'mixed';
    const isNormal = !isTrial && !isMixed;
    const isB2b = isB2bUser(student_meta.shop_id);

    const trialModalityAnnual = student_meta.trial_academic_section_modality.toUpperCase() == 'ANNUAL';
    const demoBanners = [
      {
        modalTitle: trialModalityAnnual ? t('Matricúlate ahora del primer curso') : t('Matricúlate ahora del primer semestre'),
        discountTitle: trialModalityAnnual ? t('Matricúlate ahora del primer curso') : t('Matricúlate ahora del primer semestre'),
        discountSubtitle: t("Aprovecha el descuento si te matriculas ahora."),
        buttonLabel: "¡Matricúlate ahora!",
        style: {
            backgroundColor: "black",
            buttonWidth: 300,
            textMaxWidth: 520,
        },
        discountBadge: trialModalityAnnual ? t('5% dto.') : t('10% dto.'),
        discountBadge1: "-5€"
      }
    ];

    const saleDate = (day, month, year = 2026) => ({ day, month, year });

    const createSale = ({ discountBadge, startDate, endDate, studentSaleType }) => {
        return {
          ...saleBase,
          discountBadge: t(discountBadge),
          startDate,
          endDate,
          studentSaleType,
        }
    };

    const interestFreeSales = [
        createSale({
            discountBadge: "10% dto. + Financiación SIN INTERESES",
            startDate: saleDate(3, 6),
            endDate: saleDate(9, 6),
            studentSaleType: 'semestral',
        }),
        createSale({
            discountBadge: "10% dto.",
            startDate: saleDate(10, 6),
            endDate: saleDate(1, 7),
            studentSaleType: 'semestral',
        }),
        createSale({
            // discountBadge: "5% dto. + Financiación SIN INTERESES",
            discountBadge: "5% dto.",
            startDate: saleDate(2, 7),
            endDate: saleDate(8, 7),
            studentSaleType: 'semestral',
        }),
        createSale({
            discountBadge: "5% dto.",
            startDate: saleDate(9, 7),
            endDate: saleDate(20, 7),
            studentSaleType: 'semestral',
        }),
        createSale({
            discountBadge: "16% dto.",
            startDate: saleDate(21, 7),
            endDate: saleDate(22, 7),
            studentSaleType: 'semestral',
        }),
        createSale({
            discountBadge: "5% dto.",
            startDate: saleDate(23, 7),
            endDate: saleDate(31, 7),
            studentSaleType: 'semestral',
        }),
        createSale({
            // discountBadge: "Financiación SIN INTERESES",
            discountBadge: "Financiación",
            startDate: saleDate(1, 8),
            endDate: saleDate(7, 8),
            studentSaleType: 'semestral',
        }),
        createSale({
            discountBadge: "Financiación SIN INTERESES + 5% dto.",
            startDate: saleDate(7, 9),
            endDate: saleDate(8, 9),
            studentSaleType: 'semestral',
        }),
        createSale({
            discountBadge: "5% dto.",
            startDate: saleDate(8, 9),
            endDate: saleDate(13, 9),
            studentSaleType: 'semestral',
        }),
        createSale({
            discountBadge: "5% dto. + Financiación SIN INTERESES",
            startDate: saleDate(3, 6),
            endDate: saleDate(9, 6),
            studentSaleType: 'annual',
        }),
        createSale({
            discountBadge: "5% dto.",
            startDate: saleDate(10, 6),
            endDate: saleDate(1, 7),
            studentSaleType: 'annual',
        }),
        createSale({
            // discountBadge: "Financiación SIN INTERESES",
            discountBadge: "5% dto.",
            startDate: saleDate(2, 7),
            endDate: saleDate(20, 7),
            studentSaleType: 'annual',
        }),
        createSale({
            // discountBadge: "Financiación SIN INTERESES",
            discountBadge: "11% dto.",
            startDate: saleDate(21, 7),
            endDate: saleDate(22, 7),
            studentSaleType: 'annual',
        }),
        createSale({
            // discountBadge: "Financiación SIN INTERESES",
            discountBadge: "5% dto.",
            startDate: saleDate(23, 7),
            endDate: saleDate(31, 7),
            studentSaleType: 'annual',
        }),
        createSale({
            // discountBadge: "Financiación SIN INTERESES",
            discountBadge: "5% dto.",
            startDate: saleDate(1, 8),
            endDate: saleDate(7, 8),
            studentSaleType: 'annual',
        }),
        createSale({
            discountBadge: "Financiación SIN INTERESES + 5% dto.",
            startDate: saleDate(7, 9),
            endDate: saleDate(8, 9),
            studentSaleType: 'annual',
        }),
        createSale({
            discountBadge: "5% dto.",
            startDate: saleDate(8, 9),
            endDate: saleDate(13, 9),
            studentSaleType: 'annual',
        }),
    ]

    const salesBanners = interestFreeSales.filter(
      sale => sale.studentSaleType === studentSaleType
    );

    const hasEnrollmentForNextSemester = student_meta?.next_enrolls?.length > 0;

    const bannersToRender = [
        ...(isTrial || isMixed ? demoBanners.map(b => ({ ...b, type: 'trial' })) : []),
        ...(isMixed || isNormal
            ? hasEnrollmentForNextSemester && !isB2b
              ? salesBanners.map(b => ({ ...b, type: 'sales' }))
              : []
            : []
        )
    ];

    function hasActiveOfferToday(sales) {
        const today = new Date();

        return sales.some(sale => {
            const start = new Date(sale.startDate.year, sale.startDate.month - 1, sale.startDate.day);
            const end = new Date(sale.endDate.year, sale.endDate.month - 1, sale.endDate.day, 23, 59, 59);
            return today >= start && today <= end;
        });
    }

    useEffect( async () => {

        dispatch(fetchAcademicSection(currentSemesterId));

        if(isBlackFriday() && student_meta.shop_id === 1 && isSpanishUser(student_meta.shop_id)){

            if(student_meta.formative_zone_code === 'CAT2122'){
                await checkBlackFridayBannerForCat2122()
            }else if(student_meta.formative_zone_code === 'CAT2425'){
                await checkBlackFridayBannerForCat2425()
            }
            await loadBlackFridayInfo();
        }else{
            setCartGeneratorUrl(defaultCartGeneratorUrl+desiredSemesterId)
        }

    }, []);

    useEffect(() => {
        if (location.state?.refreshConvocationResignations) {
            dispatch(convocationResignationsActiveProcess());
        }
    }, [location.state?.refreshConvocationResignations]);


    // Comunicados Functions

    const handleNotices = () => {
        const element = document.querySelector('.comunicados')
        element.scrollIntoView({ behavior: 'smooth' })
    }

    // Encryption functions

    const adaptKey = (key) => {
        const len = 32
        if (key.length >= len) {
            return key.substring(0, len)
        } else {
            return key + Array(len - key.length + 1).join("\x00");
        }
    }

    const encryptString = (studentId) => {
        const cipher = crypto.createCipheriv(
            micuentaenv.ENCRYPTION_METHOD,
            adaptKey(micuentaenv.API_ADMIN_KEYWORD),
            micuentaenv.IV_ENCRYPTION_STRING
        )
        return encodeURIComponent(Buffer.from(
            cipher.update(studentId, 'utf8', 'base64') + cipher.final('base64')
        ).toString())
    }

    /***************/
    /*  CONSTANTS  */
    /***************/

    // General Dates
    const today = new Date();
    const endDateBanner = new Date(2024, 8, 25, 23, 59, 59)

    // Birthdate Repair Block
    const birthDateRepairStatus = student_meta.student_birth_date_repair_status
    const needBirthDateRepair = (birthDateRepairStatus !== null && birthDateRepairStatus === 0)

    // has coursing enroll on current semestre

    const isCoursingByFormativeZoneAndSemestre = (formativeZone, desiredSemestre) => {
        return student_meta.coursing_enrolls.some(ce => ce.formative_zone === formativeZone && ce.academic_section_id === desiredSemestre);
    }

    const coursingByFormativeZoneCodeAndSemestre = (formativeZoneCode, desiredSemestre) => {
        let coursingFA = [];
        if(student_meta.coursing_or_finished_enrolls.length > 0){
            coursingFA = student_meta.coursing_or_finished_enrolls.filter((ce) =>
                ce.formative_zone_code === formativeZoneCode
                && ce.formative_action.shop_code.startsWith(ce.formative_zone_code) === true
                && ce.academic_section_id === desiredSemestre)
        }
        return coursingFA;
    }

    const hasUnfinishedAcademicProgram = (formativeZone) => {
        return student_meta.unfinished_academic_programs.some(ce => ce.formative_zone === formativeZone);
    }

    const hasUnfinishedAcademicProgramByFormativeZoneCode = (formativeZoneCode) => {
        return student_meta.unfinished_academic_programs.some(ce => ce.formative_zone_code === formativeZoneCode);
    }

    const hasPendingEnrolls = (formativeZone, desiredSemestre) => hasUnfinishedAcademicProgram(formativeZone) &&
        !isCoursingByFormativeZoneAndSemestre(formativeZone, desiredSemestre)

    const hasPendingEnrollsByFormativeZoneCode = (formativeZoneCode, desiredSemestre) => hasUnfinishedAcademicProgramByFormativeZoneCode(formativeZoneCode) &&
        coursingByFormativeZoneCodeAndSemestre(formativeZoneCode, desiredSemestre).length < 1

    const isCoursingMad = isCoursingByFormativeZoneAndSemestre('MAD', currentSemesterId)
    const isCoursingCat = isCoursingByFormativeZoneAndSemestre('CAT', currentSemesterId)
    const isCoursingBoth = isCoursingMad && isCoursingCat;

    // Cart Links
    const defaultCartGeneratorUrl = micuentaenv.STUDENT_ACCOUNT_API_basePath + '/enroll_next_semester?s=' + encryptString(user.id.toString()) + '&as=';
    const defaultCartGeneratorUrlBlackFriday = micuentaenv.STUDENT_ACCOUNT_API_basePath + '/get_recommended_cart_black_friday?s=' + encryptString(user.id.toString()) + '&as=';
    const defaultRecommendedProductsUrl = micuentaenv.STUDENT_ACCOUNT_API_basePath + '/get_recommended_products?s=' + encryptString(user.id.toString());


    /******************/
    /*  BLACK FRIDAY  */
    /******************/


    const isBlackFriday = () => {
        return (today >= new Date(2024, 9, 4, 0, 0, 0) && today < new Date(2024, 11, 1, 23, 59, 59))
    }

    /**
     * Conditions:
     * - Has no coursing enrolls on desired semestre
     * - Show banner only if recommended 4 or more Products (BlackFriday discounts conditions)
     *
     * Recommendation:
     * - we recommend pending Products. Same number than the currently coursing enrolls
     *
     */
    const checkBlackFridayBannerForCat2122 = async () => {

        // has no coursingEnrolls on desired semestre and has pending AcademicProgreams
        if(coursingByFormativeZoneCodeAndSemestre('CAT2122', desiredSemesterId).length === 0 && hasUnfinishedAcademicProgramByFormativeZoneCode('CAT2122')){

            // we need the recommended products because only if they are more than 4 we display the banner
            const recommendedProducts = await getHttp(defaultRecommendedProductsUrl);

            const recommendedProductsFirstSemestre =
                recommendedProducts
                    .filter((pp) => pp.semestre != "1")

            if(recommendedProductsFirstSemestre.length >= 4) {

                let recommendedFormativeActions =
                    recommendedProductsFirstSemestre.slice(0,student_meta.coursing_enrolls.length).map((pp) => {
                        return pp.reference;
                    }).join(',');

                let cartUrl = defaultCartGeneratorUrl+desiredSemesterId+'&fa='+encryptString(recommendedFormativeActions)+'&bf=1';
                setEnrollPendingBlackFriday(true)
                setCartGeneratorUrl(cartUrl)
            }
        }
    }

    /**
     * Conditions:
     * - Student is coursing or finished (preconvalidated) exactly the 1st semester
     *
     * Recommendation:
     * - We recommend the 2nd semester Pack. NO FCT/Project
     *
     */
    const checkBlackFridayBannerForCat2425 = async () => {

        // if has NO coursing enrolls on desired semestreqq
        if(coursingByFormativeZoneCodeAndSemestre('CAT2425', desiredSemesterId).length === 0){

            const cat2425CoursingEnrolls = coursingByFormativeZoneCodeAndSemestre('CAT2425', currentSemesterId)

            // if has coursing enrolls on current semestre
            if(cat2425CoursingEnrolls.length > 0){

                // we get all the products of the enrolled category from Prestashop
                const products = await dispatch(fetchPrestashopProducts(cat2425CoursingEnrolls[0]['formative_action']['shop_code']));

                // we get the coursing formative actions references
                const cat2425CoursingEnrollsFormativeActionsReferences = cat2425CoursingEnrolls.map((fsce) => {
                    return fsce.formative_action.shop_code;
                });

                // we get the ids
                const allAcademicProgramProductsReferencesFirstSemester =
                    products
                        .filter((pp) => pp.semestre == "1")
                        .map((pp) => {
                            return pp.reference;
                        });

                let coursingNotFromFirstSemester = cat2425CoursingEnrollsFormativeActionsReferences.some(fsce =>
                    !allAcademicProgramProductsReferencesFirstSemester.includes(fsce)
                );
                let notCoursinFromFirstSemester = allAcademicProgramProductsReferencesFirstSemester.some(eapfa =>
                    !cat2425CoursingEnrollsFormativeActionsReferences.includes(eapfa)
                );

                // student must be coursing or finished exactly the FA from the 1st semester: not less, not more
                if(!coursingNotFromFirstSemester && !notCoursinFromFirstSemester) {
                    const allAcademicProgramProductsReferencesSecondSemester = products
                        .filter((pp) => pp.semestre == "2")
                        .map((pp) => {
                            return pp.reference;
                        }).join(',');

                    let cartUrl = defaultCartGeneratorUrlBlackFriday+desiredSemesterId+'&fa='+encryptString(allAcademicProgramProductsReferencesSecondSemester);
                    setEnrollPendingBlackFriday(true)
                    setCartGeneratorUrl(cartUrl)
                }
            }
        }
    }


    const loadBlackFridayInfo = async () => {

        let colorClass = '';
        let backgroundClass = '';
        let discountPercentage = '';

        const week44Start = new Date(2024, 10, 4, 0, 0, 0);
        const week44End = new Date(2024, 10, 10, 23, 59, 59);

        const week45Start = new Date(2024, 10, 11, 0, 0, 0);
        const week45End = new Date(2024, 10, 17, 23, 59, 59);

        const week46Start = new Date(2024, 10, 18, 0, 0, 0);
        const week46End = new Date(2024, 10, 24, 23, 59, 59);

        const week47Start = new Date(2024, 10, 25, 0, 0, 0);
        const week47End = new Date(2024, 11, 1, 23, 59, 59);

        const studentFormativeZoneCode = student_meta.formative_zone_code;

        if (today >= week44Start && today < week44End) {
            colorClass = 'yellow';
            backgroundClass = 'yellow-background';
            if (studentFormativeZoneCode === 'CAT2122') discountPercentage = '20';
            else if (studentFormativeZoneCode === 'CAT2425') discountPercentage = '25';
            else if (studentFormativeZoneCode === 'MAD2425') discountPercentage = '15% + Premium al 50';
        } else if (today >= week45Start && today < week45End) {
            colorClass = 'red';
            backgroundClass = 'red-background';
            if (studentFormativeZoneCode === 'CAT2122') discountPercentage = '15';
            else if (studentFormativeZoneCode === 'CAT2425') discountPercentage = '20';
            else if (studentFormativeZoneCode === 'MAD2425') discountPercentage = '10% + Premium al 50';
        } else if (today >= week46Start && today < week46End) {
            colorClass = 'blue';
            backgroundClass = 'blue-background';
            if (studentFormativeZoneCode === 'CAT2122') discountPercentage = '10';
            else if (studentFormativeZoneCode === 'CAT2425') discountPercentage = '15';
            else if (studentFormativeZoneCode === 'MAD2425') discountPercentage = '10% + Premium al 50';
        } else if (today >= week47Start && today < week47End) {
            colorClass = 'purple';
            backgroundClass = 'purple-background';
            if (studentFormativeZoneCode === 'CAT2122') discountPercentage = '5';
            else if (studentFormativeZoneCode === 'CAT2425') discountPercentage = '10';
            else if (studentFormativeZoneCode === 'MAD2425') discountPercentage = '5% + Premium al 50';
        }

        setColorClass(colorClass)
        setBackgroundClass(backgroundClass)
        setDiscountPercentage(discountPercentage)

    }

    /**********************/
    /*  END BLACK FRIDAY  */
    /**********************/


    const renderStartAnnualCourseInfo = () => {
        if ('es' === lang && today <= endDateBanner) {
            return (
                <div className='card-dashboard-info'>
                    <div className='card-dashboard-info__content'>
                        <p className='no-margin-top'><b>{t('dashboard_banner_title_mad')}</b></p>
                        <ul className={'no-margin'}>
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_apertura_asignaturas') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_inicio_semestre_mad') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_inicio_tutorias') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_apertura_pacs') }} />
                        </ul>
                        <p className='no-margin-bottom'>{t('dashboard_banner_footer')}</p>
                    </div>
                </div>
            )
        }
    }

    const renderEnrollRecommenderBlackFridayInfo = () => {
        if ('es' === lang) {
            return (
                <div style="">
                    <div className="blackFridayContainer">
                        <div className='card-dashboard-info inverse black-friday'>
                            <div className='card-dashboard-info__content'>
                                <p className='m-top margin-bottom title'><b><span className={"black-friday-title " + colorClass}>{t('dashboard_banner_enroll_recommender_black_friday_title_coloured')}</span>{t('dashboard_banner_enroll_recommender_black_friday_title')}</b></p>
                                <p className='no-margin-top' dangerouslySetInnerHTML={{ __html: t('dashboard_banner_enroll_recommender_black_friday_subtitle').replace('{discount_percentage}', discountPercentage) }} />
                                <ol >
                                    <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_enroll_recommender_black_friday_step_1') }} />
                                    <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_enroll_recommender_black_friday_step_2') }} />
                                </ol>
                                <a className="btn btn-default m-top m-bottom-half sm-no-full-width full-width" href={cartGeneratorUrl} type="button" target="_blank">{t('dashboard_banner_enroll_recommender_black_friday_button')}</a>
                            </div>
                            <div className={"binding internal " + backgroundClass}><span>Black Friday</span><span>Black Friday</span><span>Black Friday</span><span>Black Friday</span><span>Black Friday</span></div>
                        </div>
                        <div className={"binding external " + backgroundClass}><span>Black Friday</span><span>Black Friday</span><span>Black Friday</span><span>Black Friday</span><span>Black Friday</span><span>Black Friday</span></div>
                    </div>
                </div>
            )
        }
    }

    const renderEnrollRecommenderInfo = () => {
        if ('es' === lang) {
            return (
                <div className='card-dashboard-info'>
                    <div className='card-dashboard-info__content'>
                        <p className='m-top-half title'><b>{t('dashboard_banner_enroll_recommender_title')}</b></p>
                        <p className='no-margin-top' dangerouslySetInnerHTML={{ __html: t('dashboard_banner_enroll_recommender_subtitle') }} />
                        <ol className={'no-margin'}>
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_enroll_recommender_step_1') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_enroll_recommender_step_2') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_enroll_recommender_step_3') }} />
                        </ol>
                        <p className='no-margin-bottom'><b>{t('dashboard_banner_enroll_recommender_footer')}</b></p>
                        <a className="btn btn-ghost m-top m-bottom-half sm-no-full-width full-width" href={cartGeneratorUrl} type="button" target="_blank">{t('dashboard_banner_enroll_recommender_button')}</a>
                    </div>
                </div>
            )
        }
    }

    const renderStartSemestralCourseInfo = () => {
        if ('es' === lang && today <= endDateBanner) {
            return (
                <div className='card-dashboard-info'>
                    <div className='card-dashboard-info__content'>
                        <p className='no-margin-top'><b>{t('dashboard_banner_title')}</b></p>
                        <ul className={'no-margin'}>
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_apertura_asignaturas') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_inicio_semestre_cat') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_inicio_tutorias') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_apertura_pacs') }} />
                        </ul>
                        <p className='no-margin-bottom'>{t('dashboard_banner_footer')}</p>
                    </div>
                </div>
            )
        }
    }

    const renderStartBothPlansInfo = () => {
        if ('es' === lang && today <= endDateBanner) {
            return (
                <div className='card-dashboard-info'>
                    <div className='card-dashboard-info__content'>
                        <p className='no-margin-top'><b>{t('dashboard_banner_title_mad')}</b></p>
                        <ul className='no-margin'>
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_apertura_asignaturas') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_inicio_semestre_mad_both') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_inicio_semestre_cat_both') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_inicio_tutorias') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('dashboard_banner_apertura_pacs') }} />
                        </ul>
                        <p className='no-margin-bottom'>{t('dashboard_banner_footer')}</p>
                    </div>
                </div>
            )
        }
    }

    const conditionBadge = (status) => {
        switch (status.toUpperCase()) {
            case 'VALIDADO':
                return 'success';
            case 'RECHAZADO':
                return 'danger';
            default:
                return 'warning';
        }
    }

    const getFctBadgeTitle = (contract) => {
        switch (contract.formative_zone_code.toUpperCase()) {
            case 'MAD2425':
                return t('Fase de Formación en la Empresa');
            case 'CAT2425':
                return t('Estancia en la empresa');
            default:
                return t('FCT');
        }
    }

    const formatAcademicProgramNamesWithAnd = (names) => {
        if (names.length === 1) return names[0];
        if (names.length === 2) return `${names[0]} y ${names[1]}`;
        return `${names.slice(0, -1).join(', ')} y ${names[names.length - 1]}`;
    };

    const formatDate = (date) => {
        const d = new Date(date);
        return d.toLocaleDateString('es-ES', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    return (academicSection) &&
        <AppPage name="dashboard">
            <div className={`dashboard-container ${!isMobile ? 'max-width-1380' : ''}`}>
                <C className={`dashboard ${!isMobile ? 'max-width-980' : ''}`}>
                    <h1 className='hero m-x2-bottom max-h-[55px]'>{t('Hola,')} {user.name}.</h1>
                    {isCoursingBoth && renderStartBothPlansInfo()}
                    {isCoursingMad && !isCoursingBoth && renderStartAnnualCourseInfo()}
                    {isCoursingCat && !isCoursingBoth && renderStartSemestralCourseInfo()}
                    {/*{enrollPendingBlackFriday && renderEnrollRecommenderBlackFridayInfo()}*/}
                    {bannersToRender?.map((banner, i) =>
                      banner.type === 'trial' ? (
                        <TrialBanner
                          key={i}
                          {...banner}
                          studentMeta={student_meta}
                          user={user}
                        />
                      ) : (
                        <SalesBanner
                          key={i}
                          {...banner}
                          studentMeta={student_meta}
                          user={user}
                        />
                      )
                    )}
                    {/* {!hasActiveOfferToday(interestFreeSales) &&
                        <SalesBanner
                            buttonLabel={t('¡Matricúlate ahora!')}
                            studentMeta={student_meta}
                            discountTitle={t('Matricúlate ahora para el próximo semestre')}
                            user={user}
                            style={{
                                backgroundColor: "#031C21",
                                buttonWidth: 250,
                                textCenter: true,
                                textMaxWidth: 420
                            }}
                        />
                    } */}
                    {/* { student_meta.shop_id === 1 && (
                            hasPendingEnrollsByFormativeZoneCode('CAT2425', desiredSemesterId) ||
                            hasPendingEnrollsByFormativeZoneCode('MAD2425', desiredCursId))
                        && renderEnrollRecommenderInfo()} */}


                    <div>
                        {!availabeToFinishCAT2122 && academicProgramNamesCAT2122.length > 0 && (
                            <Banner color='error' className='m-x2-bottom m-top-x2' background="error">
                                <p>{t('¡Hola, Onliner!')}</p><br/>
                                <p>
                                    <span dangerouslySetInnerHTML={{__html: t('Si quieres continuar estudiando el ciclo')}}></span> 
                                    <strong className="t-underline">{formatAcademicProgramNamesWithAnd(academicProgramNamesCAT2122)}</strong>
                                    <span dangerouslySetInnerHTML={{__html: t('debes actualizar tu plan formativo.')}}></span>
                                </p><br/>
                                <p dangerouslySetInnerHTML={{__html: t('tu plan actual')}}></p>
                            </Banner>
                        )}

                        {
                            convocationResignations && (
                                <Banner className='m-x2-bottom d-flex flex-baseline-y'>
                                    {convocationResignations && (
                                        !convocationResignations.is_extraordinary ? (
                                            <span class="text-responsive"
                                                dangerouslySetInnerHTML={{__html: t('Si necesitas renunciar a alguna de tus convocatorias')}}></span>
                                        ) : (
                                            <span class="text-responsive"
                                                dangerouslySetInnerHTML={{__html: t('Si necesitas renunciar a tu convocatioria extraordinaria')}}></span>
                                        )
                                    )}
                                    <span className='font-bold text-responsive'>{formatDate(convocationResignations.end_date)}.</span>
                                    <p class="m-top-half text-responsive"> {t('Para más información y detalles sobre el proceso de solicitud, haz clic aquí: ')}
                                        <Link className='font-bold hover-line text-responsive' to='/convocation-resignations'>{t('Más información sobre la renuncia.')}</Link>
                                    </p>
                                </Banner>
                            )
                        }

                        {needBirthDateRepair && <div className='font-18 m-bottom dashboard__notify'>
                        <span>⚠️ {t('dashboard_birth_date_discrepancy_text')} <Link
                            className='font-color-149BAB' to='/student/birth-date'>{t('dashboard_birth_date_discrepancy_link')}</Link></span>
                        </div>}
                        {student_meta.has_pending_exam_inscriptions && <div className='font-18 m-bottom dashboard__notify'>
                        <span>👉 {t('Tienes inscripciones a exámenes pendientes')}. <Link className='font-color-149BAB'
                                                                                         to='/examenes'>{t('Realiza las inscripciones')}</Link></span>
                        </div>}
                        {student_meta.has_pending_class_inscriptions && <div className='font-18 m-bottom dashboard__notify'>
                        <span>👉 {t('Tienes inscripciones a clases presenciales pendientes')}. <Link
                            className='font-color-149BAB' to='/clases'>{t('Realiza las inscripciones')}</Link></span>
                        </div>}
                        {comunicados_status?.unread > 0 && (
                            <div className='font-18 m-bottom dashboard__notify'>
                                👋 <span> {(comunicados_status.unread === 1)
                                ?
                                <span>{t('Tienes {num} comunicado sin leer').replace('{num}', comunicados_status.unread)}. <span
                                    onClick={handleNotices}
                                    className='font-color-149BAB t-underline cursor-pointer'>{t('Leer comunicado')}</span></span>
                                :
                                <span>{t('Tienes {num} comunicados sin leer').replace('{num}', comunicados_status.unread)}. <span
                                    onClick={handleNotices}
                                    className='font-color-149BAB t-underline cursor-pointer'>{t('Leer comunicados')}</span></span>
                            }</span>
                            </div>
                        )}
                    </div>

                    <div className='d-flex m-top dashboard__panel'>
                        {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) && student_meta.canvas_access && !window.isMobileApp &&
                            <Card title={t('Campus')} to={student_meta.online_campus_url}
                                  content={t('Accede a los contenidos y aulas virtuales de tus asignaturas.')}
                                  external
                                  fullWidth
                            />}
                        {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) &&
                            <Card title={t('Expediente académico')}
                                  fullWidth
                                  content={t('Consulta tus notas, asignaturas y el estado de tu expediente.')}
                                  to='/expediente' />}
                        {student_access === STUDENT_IS_ON_SITE && student_meta.canvas_access &&
                            <Card title={t('Campus Presencial')} inverse to={student_meta.presential_campus_url} external />}
                        {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) && student_meta?.fct_contracts.map(fct =>
                            <Card title={getFctBadgeTitle(fct)}
                                  to={`/fct/${fct.contract_id}`}
                                  fullWidth
                                  content={
                                    <Fragment>
                                        <div>{t(fct.program)}</div>
                                        {fct.status &&
                                            <Badge className='m-top' type='warning'>{t(fct.status)}</Badge>
                                        }
                                    </Fragment>
                                  }
                            />)}
                        {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) && student_meta?.fct_precontracts.map(fct =>
                            <Card title={t('EXENCION100')} to={`/exemption/${fct.precontract_id}`} fullWidth content={
                                <Fragment>
                                    <div>{t(fct.program)}</div>
                                    {fct.status &&
                                        <Badge className='m-top' type={conditionBadge(fct.status)}>{t(fct.status)}</Badge>
                                    }
                                </Fragment>
                            }
                            />)}
                        {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) && student_meta.has_formalized_expedient === true &&
                            <Card title={t('Secretaría')}
                                  fullWidth
                                  content={t('Solicita certificados o realiza otras gestiones administrativas con el departamento de Secretaría.')}
                                  to='/secretaria' />}
                        {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) && isSpanishUser(student_meta.shop_id) &&
                            <Card title={t('Bolsa de trabajo')}
                                  fullWidth
                                  content={t('Busca ofertas de empleo relacionadas con tu ciclo formativo en empresas de tu zona.')}
                                  to='/jobs' />}
                        {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) && !student_meta.is_eso && student_meta.enrolled_academic_programs.length > 0 &&
                            <Card title={t('Área Onliner')}
                                  fullWidth
                                  content={t('Consulta información académica y los tutoriales de ayuda.')}
                                  to='/online-area' />}
                        {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) && isSpanishUser(student_meta.shop_id) &&
                            <CardHelp fullWidth />
                        }
                    </div>
                    {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE || student_access === STUDENT_NO_VALIDATED) && isMobile &&
                        <div className="full-width m-top-x2">
                            <CardSession />
                        </div>
                    }
                    <div className='m-top-x2'>
                        <Comunicados isolateComponent />
                    </div>
                </C>
                {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) && !isMobile &&
                    <div>
                        <CardSession />
                    </div>
                }
            </div>
        </AppPage>

}
